module.exports = __webpack_public_path__ + "static/media/icon_24.7098fbb2.svg";